<template>
    <div>
        <el-menu class="el-menu-demo" mode="horizontal" :ellipsis="false" :router="true" background-color="#030F6B"
            text-color="#FBFDFF">

            <el-menu-item class="hidden-md-and-down" index="/">
                <img style="width: 150px" src="@/assets/logo.png" alt="Logo Putra Bandung" />
            </el-menu-item>
            <div class="flex-grow" />
            <el-menu-item v-if="permission.indexOf('View User')>=0" index="/user">Pengguna</el-menu-item>
            <el-menu-item v-if="permission.indexOf('View Permission')>=0" index="/permission">Hak Akses</el-menu-item>
            <el-menu-item v-if="permission.indexOf('View Flow')>=0" index="/flow">Aktivitas</el-menu-item>
            <el-menu-item v-if="permission.indexOf('View LOV')>=0" index="/lov">LOV</el-menu-item>
            <el-menu-item v-if="permission.indexOf('View Report')>=0" index="/report">Laporan</el-menu-item>
            <el-menu-item v-if="permission.indexOf('View Map')>=0" index="/dashboard">Dasboard</el-menu-item>
            <el-menu-item v-if="permission.indexOf('View Map')>=0" index="/map">Peta</el-menu-item>
            <UserMenu />
        </el-menu>
    </div>
</template>



<script>
import 'element-plus/theme-chalk/display.css'
import { defineComponent } from 'vue'
import UserMenu from './UserMenu.vue'

export default defineComponent({
    name: 'MainMenu',
    components: {
        UserMenu
    },
    data() {
        return {
            activeIndex: "/",
            permission:[],
            user: {}
        }
    },
    created() {
        if(localStorage.user!=undefined){
            const user = JSON.parse(localStorage.user)
            this.user = user
            user.permissions.map((role)=>{
                if(role.module_name=="Web Putra"){
                    this.permission = role.permissions.split(",")
                }
            })
        }
    }
})
</script>

<style scoped>
.flex-grow {
    flex: 1;
}

.el-menu-demo {
    display: flex;
    align-items: center;
}

:deep(.user-menu) {
    margin-left: 12px;
}
</style>
